<template>
  <div id="childPreferences">
    <v-form ref="formEdit">
      <v-container>
        <v-layout wrap class="button-container pr-4" :class="{'pl-4': $vuetify.breakpoint.smAndUp}">
          <v-flex xs12 sm12 md12 class="pr-0 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pb-4 pt-3">
            <v-flex xs12 sm6>
              <v-select 
                v-model="childPreferences.gender" 
                @change="changedData" 
                attach small-chips deletable-chips multiple
                :items="genderPref" 
                label="Gender" 
                class="pr-4 pl-4">
              </v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select 
                v-model="childPreferences.number_of_children" 
                @change="changedData" 
                :items="NoOfChildren" 
                attach small-chips deletable-chips 
                label="No of children desired" 
                multiple 
                class="pr-4 pl-4">
              <template v-slot:prepend-item>
                <v-list-tile
                  ripple
                  @click="toggleSelectAll('number_of_children', 4, NoOfChildren)"
                >
                  <v-list-tile-action>
                    <v-icon :color="childPreferences.number_of_children.length > 0 ? 'indigo darken-4' : ''">{{ icon('number_of_children', 4) }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Select All</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider class="mt-2"></v-divider>
              </template>
             </v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select 
                v-model="childPreferences.age" 
                @change="changedData" 
                :items="agePreference" 
                attach small-chips deletable-chips 
                label="Age Preference(s)" 
                multiple 
                class="pr-4 pl-4">
                <template v-slot:prepend-item>
                <v-list-tile
                  ripple
                  @click="toggleSelectAll('age', 13, agePreference)"
                >
                  <v-list-tile-action>
                    <v-icon :color="childPreferences.age.length > 0 ? 'indigo darken-4' : ''">{{ icon('age', 13) }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Select All</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider class="mt-2"></v-divider>
              </template>
              </v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select 
                v-model="childPreferences.ethnicity" 
                @change="changedData" 
                :items="ethinicityPref" 
                attach small-chips deletable-chips 
                label="Ethinicity Preference(s)" 
                multiple class="pr-4 pl-4">
                <template v-slot:prepend-item>
                <v-list-tile
                  ripple
                  @click="toggleSelectAll('ethnicity', 19, ethinicityPref)"
                >
                  <v-list-tile-action>
                    <v-icon :color="childPreferences.ethnicity.length > 0 ? 'indigo darken-4' : ''">{{ icon('ethnicity', 19) }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Select All</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider class="mt-2"></v-divider>
              </template>
              </v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select 
                v-model="childPreferences.adoption_type" 
                @change="changedData" 
                :items="adoptionType" 
                attach small-chips deletable-chips 
                label="Adoption Type" 
                multiple class="pr-4 pl-4">
                <template v-slot:prepend-item>
                <v-list-tile
                  ripple
                  @click="toggleSelectAll('adoption_type', 3, adoptionType)"
                >
                  <v-list-tile-action>
                    <v-icon :color="childPreferences.adoption_type.length > 0 ? 'indigo darken-4' : ''">{{ icon('adoption_type', 3) }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Select All</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider class="mt-2"></v-divider>
              </template>
              </v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select 
                v-model="childPreferences.birth_father_status" 
                @change="changedData" 
                :items="birthFather" 
                attach small-chips deletable-chips 
                label="Birth Father Status(es)" 
                multiple class="pr-4 pl-4">
                <template v-slot:prepend-item>
                <v-list-tile
                  ripple
                  @click="toggleSelectAll('birth_father_status', 5, birthFather)"
                >
                  <v-list-tile-action>
                    <v-icon :color="childPreferences.birth_father_status.length > 0 ? 'indigo darken-4' : ''">{{ icon('birth_father_status', 5) }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Select All</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider class="mt-2"></v-divider>
              </template>
              </v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-switch 
                v-model="childPreferences.ready_to_adopt_special_need_child" 
                @change="changedData" 
                label="Special Needs" 
                class="pr-4 pl-4">
              </v-switch>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select 
                v-model="childPreferences.special_needs" 
                @change="changedData" 
                v-show="childPreferences.ready_to_adopt_special_need_child" 
                :items="specialNeedOption" 
                attach small-chips deletable-chips 
                label="Special Need Option(s)" 
                multiple 
                class="pr-4 pl-4">
                 <template v-slot:prepend-item>
                <v-list-tile
                  ripple
                  @click="toggleSelectAll('special_needs', 32, specialNeedOption)"
                >
                  <v-list-tile-action>
                    <v-icon :color="childPreferences.special_needs.length > 0 ? 'indigo darken-4' : ''">{{ icon('special_needs', 32) }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Select All</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider class="mt-2"></v-divider>
              </template>
              </v-select>
            </v-flex>
        </v-layout>

        <v-layout class="button-container pr-4" :class="{'pl-4': $vuetify.breakpoint.smAndUp}"> 
          <v-flex xs12 sm12 md12 v-if="selectedData" class="pr-0 text-xs-right">
            <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>


      </v-container>
    </v-form>
  </div>
</template>
<script>
/* global session store */
import { mapGetters } from 'vuex';
import { getOne, update } from '../helpers/helpers';
import swal from 'sweetalert2';
export default {
  name: 'child-preferences',
  components: {

  },
  data: () => ({
    accountDetails: {},
    childPreferences: {
      gender: [],
      number_of_children: [],
      age: [],
      ethnicity: [],
      adoption_type: [],
      birth_father_status: [],
      ready_to_adopt_special_need_child: false,
      special_needs: []
    },
    genderPref: [
      { text: '--select--', value: '' },
      'Male',
      'Female',
      'Either'
    ],
    agePreference: [
      'Newborn',
      'Newborn - 3 months',
      'Newborn - 6 months',
      'Newborn - 9 months',
      '1 year old',
      '2 years old',
      '3 years old',
      '4 years old',
      '5 years old',
      '6 years old',
      '7 years old',
      '8 years old',
      'Over 8 years old',
    ],
    adoptionType: [
      'Closed',
      'Open',
      'Semi-Open'
    ],
    ethinicityPref: [
      'African American',
      'African American/Asian',
      'African American/Native American',
      'Asian',
      'Asian/Hispanic',
      'Asian/Native American',
      'Bi-Racial',
      'Caucasian',
      'Caucasian/African American',
      'Caucasian/Asian',
      'Caucasian/Hispanic',
      'Caucasian/Native American',
      'European',
      'Hispanic',
      'Hispanic/African American',
      'Hispanic/Native American',
      'Middle Eastern',
      'Native American',
      'Pacific Islander'
    ],
    birthFather: [
      'Birth Father Known',
      'Birth Father Unknown',
      'Conceived Through Incest',
      'Conceived Through Rape',
      'Multiple Birth fathers'
    ],
    specialNeedOption: [
      'ADD/ADHD',
      'Alcohol exposed(occasional)',
      'Autism/ Autism Spectrum Disorder',
      'Blindness',
      'Club Foot',
      'Cleft Pallet or lip',
      'Conceived through rape',
      'Conceived through incest',
      'Deafness',
      'Diabeties in Child',
      'Diabeties in Family',
      'Down Syndrome',
      'Drug Exposed (occasional)',
      'Emotional/mental disorders  in family',
      'Epilepsy in Family',
      'Fetal Alcohol Effects',
      'Family mental retardation',
      'HIV/AIDS',
      'limited life expectancy',
      'Mental Retardation',
      'Mild or medically correctable',
      'Multiple Birth',
      'Nothing known about father',
      'Nothing known about mother',
      'Premature Birth',
      'Requires specialized care',
      'Requires life long medical treatment',
      'Smoking Exposed',
      'Seizures',
      'Sibling group',
      'Sickle Cell Anemia or Trait',
      'Terminally ill'
    ],
    NoOfChildren: [
      'One child',
      'Twins',
      'Triplets',
      'Siblings'
    ],
    selectedData: false
  }),
  computed: {
    ...mapGetters(['Account']),
    icon () {
      return (key, count) => {
        if (this.childPreferences[key].length === count) return 'check_box';
        if (this.childPreferences[key].length === 0) return 'check_box_outline_blank';
        return 'indeterminate_check_box';
      };
    }
  },
  created () {
    this.accountDetails = JSON.parse(JSON.stringify(this.Account));
    if (this.accountDetails.preference) {
      this.childPreferences = { ...this.accountDetails.preference };
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    toggleSelectAll (key, count, list) {
      this.selectedData = true;
      this.$nextTick(() => {
        if (this.childPreferences[key].length === count) {
          this.childPreferences[key] = [];
        } else {
          this.childPreferences[key] = list.slice();
        }
      });
    },
    async save () {
      if (this.$refs.formEdit.validate()) {
        this.selectedData = false;
        if (this.childPreferences.ready_to_adopt_special_need_child === false) {
          this.childPreferences.special_needs = [];
        }
        this.accountDetails.preference = this.childPreferences;
        this.accountDetails.updated_from = 'childPreferences';
        let entity = `Account`;
        let { error, data, status } = await update(entity, this.accountDetails, session.getSession().adminUser ? session.getSession().user.human.account.id : 'Me');
        if (error) {
          console.log('error', error);
        } else {
          this.loading = false;
          store.commit('setAccount', data);
          swal.fire({
            type: 'success',
            title: 'Child preferences updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.selectedData = false;
            }
          });
        }
      }
    },
    changedData () {
      this.selectedData = true;
    },
    hideButtons () {
      if (this.accountDetails.preference) {
        this.childPreferences = { ...this.accountDetails.preference };
      } else {
        this.$refs.formEdit.reset();
      }
      this.selectedData = false;
    }
  }
};
</script>


<style scoped>
.cancel_btn {
  background-color: #f094be !important;
}
@media(max-width:410px){
  .pf-btn{
    min-width: 85px;
  }
}
#childPreferences >>> .accent--text {
    color: #019d8c !important;
    caret-color: #019d8c !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/ChildPreferences.vue